import { render, staticRenderFns } from "./HairStylists.vue?vue&type=template&id=06cea512&lang=pug&"
import script from "./HairStylists.vue?vue&type=script&lang=ts&"
export * from "./HairStylists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports